import { Component } from '@angular/core';
import { IconComponent } from '../../shared';
import { RESOURCES } from '../../content/home.content';

@Component({
  selector: 'app-audit-resources',
  imports: [IconComponent],
  templateUrl: './audit-resources.component.html'
})
export class AuditResourcesComponent {
  readonly content = RESOURCES;
}
